// Single source of truth for all user-facing command strings and rationale templates.
// Never hardcode these in web/ — import from here only.

export const COMMANDS = {
  glucose: {
    name:    "24-HOUR WATER FAST",
    cmd:     "INITIATE 24-HOUR WATER FAST.",
    rat:     (value) => `GLYCEMIC FRICTION DETECTED (${value.toFixed(1)} MMOL/L).`,
    color:   "var(--accent-red)",
    border:  "var(--accent-red)",
    level:   "critical",
    briefing: (value, threshold) =>
      `Your fasting glucose read ${value.toFixed(1)} mmol/L, above your threshold of ${threshold} mmol/L. A 24-hour fast resets insulin sensitivity and brings glucose back into range.`,
  },
  hrv: {
    name:    "ZONE 2 OUTPUT",
    cmd:     "EXECUTE 45-MIN ZONE 2 OUTPUT.",
    rat:     (value) => `AUTONOMIC STRESS DETECTED (${Math.round(value)} MS HRV).`,
    color:   "var(--text-main)",
    border:  "var(--accent-amber)",
    level:   "warn",
    briefing: (value, threshold) =>
      `Your HRV read ${Math.round(value)}ms, below your threshold of ${threshold}ms. Zone 2 training stimulates parasympathetic recovery and rebuilds HRV over time.`,
  },
  rhr: {
    name:    "ACTIVE RECOVERY PROTOCOL",
    cmd:     "INITIATE ACTIVE RECOVERY PROTOCOL.",
    rat:     (value) => `CARDIAC LOAD ELEVATED (${value} BPM RHR).`,
    color:   "var(--text-main)",
    border:  "var(--accent-amber)",
    level:   "warn",
    briefing: (value, threshold) =>
      `Your resting heart rate read ${value} bpm, above your threshold of ${threshold} bpm. Active recovery — light movement, no training load — allows your cardiovascular system to reset.`,
  },
  sleepDurationWarn: {
    name:    "SLEEP PROTOCOL",
    cmd:     "INITIATE SLEEP PROTOCOL TONIGHT.",
    rat:     (value) => `${value.toFixed(1)}H LAST NIGHT — TARGET 8H.`,
    color:   "var(--text-main)",
    border:  "var(--accent-amber)",
    level:   "warn",
    briefing: (value) =>
      `You slept ${value.toFixed(1)} hours last night. Target is 8h. Prioritise sleep tonight.`,
  },
  sleepDurationCritical: {
    name:    "SLEEP PROTOCOL",
    cmd:     "ACUTE SLEEP DEFICIT. RECOVERY REQUIRED.",
    rat:     (value) => `${value.toFixed(1)}H LAST NIGHT — CRITICALLY LOW.`,
    color:   "var(--text-main)",
    border:  "var(--accent-red)",
    level:   "critical",
    briefing: (value) =>
      `You slept ${value.toFixed(1)} hours last night. This is an acute deficit. Prioritise sleep immediately — reduce obligations tonight.`,
  },
  nominal: {
    name:    "",
    cmd:     "BIOLOGY OPTIMAL.",
    rat:     "",
    color:   "var(--text-main)",
    border:  "var(--accent-green)",
    level:   "optimal",
    briefing: () => "All four vectors are within range. No action required today.",
  },
  awaitingTelemetry: {
    name:    "",
    cmd:     "AWAITING TELEMETRY.",
    rat:     "",
    color:   "var(--text-dim)",
    border:  "var(--text-dim)",
    level:   "awaiting",
    briefing: () => "No data from any source yet. Connect Oura or bring the Gen3 ring into Bluetooth range.",
  },
};
